import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login/index'
import home from '@/views/home/index'
import user from '@/views/system/user'
import userGroup from '@/views/system/userGroup'
import role from '@/views/system/role'
import menu from '@/views/system/menu'
import community from '@/views/back/community'
import house from '@/views/back/house'
import houseCancel from '@/views/back/houseCancel'
import cooperateHouse from '@/views/back/cooperateHouse'
import room from '@/views/back/room'
import roomDetail from '@/views/back/roomDetail'
import feeDetail from '@/views/back/feeDetail'
import houseOwner from '@/views/back/houseOwner'
import cooperateHouseOwner from '@/views/back/cooperateHouseOwner'
import settlement from '@/views/back/settlement'
import performanceRecord from '@/views/back/performanceRecord'
import otherFee from '@/views/back/otherFee'
import feeOut from '@/views/back/feeOut'
import backSettlement from '@/views/back/backSettlement'
import rentCollectRecord from '@/views/back/rentCollectRecord'
import renewal from '@/views/back/renewal'
import cooperateManage from '@/views/back/cooperateManage'
import cooperateRoom from '@/views/back/cooperateRoom'
import cooperateRoomDetail from '@/views/back/cooperateRoomDetail'
import rentContract from '@/views/back/rentContract'
import rentRecordDetail from '@/views/back/rentRecordDetail'
import houseOwnerDetail from '@/views/back/houseOwnerDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/rentContract',
      name: '生成合同',
      hidden: true,
      component: rentContract
    },
    {
      path: '/',
      name: '登录',
      hidden: true,
      component: login
    }, {
      path: '/home',
      name: '首页',
      component: home,
      hidden: true
    }, {
      path: '/home',
      component: home,
      name: '系统管理',
      code: 'system',
      iconCls: 'fa fa-cogs',
      children: [
        {
          path: '/user',
          name: '用户管理',
          code: 'system_user',
          component: user
        }, {
          path: '/role',
          name: '角色管理',
          code: 'system_role',
          component: role
        }, {
          path: '/menu',
          name: '菜单管理',
          code: 'system_menu',
          component: menu
        },
        {
          path: '/userGroup',
          name: '分组管理',
          code: 'system_user_group',
          component: userGroup
        }
      ]
    }, {
      path: '/back',
      component: home,
      name: '后台设置',
      code: 'back',
      iconCls: 'fa fa-desktop',
      children: [
        {
          path: '/community',
          name: '小区管理',
          code: 'back_community',
          component: community
        },
        {
          path: '/house',
          name: '房源管理',
          code: 'back_house',
          component: house
        },
        {
          path: '/houseCancel',
          name: '房源管理',
          code: 'back_house_cancel',
          component: houseCancel
        },
        {
          path: '/cooperateHouse',
          name: '合作房源',
          code: 'back_cooperate_house',
          component: cooperateHouse,
          hidden: true
        },
        {
          path: '/cooperateRoom',
          name: '合作房间',
          code: 'back_cooperate_room',
          component: cooperateRoom,
          hidden: true
        },
        {
          path: '/contract',
          name: '合同下载',
          code: 'back_contract',
          component: rentContract,
          hidden: true
        },
        {
          path: '/houseOwner',
          name: '房东交租',
          code: 'back_house_owner',
          component: houseOwner
        },
        {
          path: '/cooperateHouseOwner',
          name: '房东交租',
          code: 'back_cooperate_house_owner',
          component: cooperateHouseOwner
        },
        {
          path: '/houseFee',
          name: '费用明细',
          code: 'back_house_fee',
          component: feeDetail
        },
        {
          path: '/houseSettlement',
          name: '结算',
          code: 'back_house_settlement',
          component: settlement
        },
        {
          path: '/room',
          name: '房间管理',
          code: 'back_room',
          component: room
        },
        {
          path: '/roomDetail',
          name: '房间明细',
          code: 'back_room_detail',
          component: roomDetail
        },
        {
          path: '/cooperateRoomDetail',
          name: '合作房间明细',
          code: 'back_cooperate_room_detail',
          component: cooperateRoomDetail
        },
        {
          path: '/houseOwnerDetail',
          name: '交租合同明细',
          code: 'back_house_owner_detail',
          component: houseOwnerDetail
        },
        {
          path: '/rentRecordDetail',
          name: '租房合同明细',
          code: 'back_rent_record_detail',
          component: rentRecordDetail
        },
        {
          path: '/performanceRecord',
          name: '业绩管理',
          code: 'back_performance_record',
          component: performanceRecord
        },
        {
          path: '/otherFee',
          name: '水电收支',
          code: 'back_other_fee',
          component: otherFee
        },
        {
          path: '/feeOut',
          name: '费用支出',
          code: 'back_fee_out',
          component: feeOut
        },
        {
          path: '/backSettlement',
          name: '盈利结算',
          code: 'back_settlement',
          component: backSettlement
        },
        {
          path: '/rentCollectRecord',
          name: '收交管理',
          code: 'rent_collect_record',
          component: rentCollectRecord
        },
        {
          path: '/renewal',
          name: '续签管理',
          code: 'back_renewal',
          component: renewal
        },
        {
          path: '/cooperate',
          name: '合作管理',
          code: 'back_cooperate',
          component: cooperateManage
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js